import styledWeb from 'styled-components';

export const IFrame = styledWeb('iframe')`
  height: 100%;
  border: 0;
`;
